import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { connect } from 'react-redux';

//componentes
import AppLayout from './components/AppLayout';
import Private from './components/Private';

//pages
import Products from './page/products/Products';
import Stock from './page/stock/Stock';
import Sales from './page/sales/Sales';
import SalesItem from './page/sales/SalesItem';
import Customers from './page/customers/Customers';
import Category from './page/category/Category';
import Login from './page/Login';
import Dashboard from './page/dashboard/Dashboard';
import Settings from './page/Settings';
import Reportes from './page/reportes/Reportes';
class App extends React.Component {
   render() {
      //const {auth:{isOk}}=this.props;
      return (
         <BrowserRouter>
            <Routes>
               <Route path='/' element={<AppLayout />}>
                  <Route index element={<Private ele={Dashboard} />} />
                  <Route path='products' element={<Private ele={Products} />} />
                  <Route path='products/categories' element={<Private ele={Category} />} />

                  <Route path='stock' element={<Private ele={Stock} />} />
                  <Route path='sales' element={<Private ele={Sales} />} />
                  <Route path='sales/item' element={<Private ele={SalesItem} />} />

                  <Route path='customers' element={<Private ele={Customers} />} />

                  <Route path='reportes' element={<Private ele={Reportes} />} />

                  <Route path='settings' element={<Private ele={Settings} />} />
               </Route>

               <Route path='/login' element={<Login />} />
               <Route path='*' element={<span>404</span>} />
            </Routes>
         </BrowserRouter>
      );
   }
}

const mapStateToProps = (state) => {
   return {
      auth: state.auth,
   };
};
const mapDispatchToProps = (dispatch) => {
   return {
      dispatch: dispatch,
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
